module.exports = __webpack_public_path__ + "static/media/blog-detail2.545d5b95.svg";